import { SwiperProps } from "swiper/react";

export const swiperConfiguration: SwiperProps = {
	slidesPerView: "auto",
	observer: true,
	threshold: 5,
};
